





































































































import CreateMusicViewModel from "@models/music/createMusicViewModel";
import { COVER_IMAGE_RATIO, BACKGROUND_IMAGE_RATIO } from "@/appSettings";
import Vue from "vue";
import { Component } from "vue-property-decorator";
import AnimationResponse from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/AnimationService/AnimationResponse";
import MusicAudioViewModel from "@models/music/musicAudioViewModel";
import CategoryViewModel from "@models/categoryViewModel";

@Component
export default class CreateMusicComponent extends Vue {
  languages: string[] = [];
  isLoading = false;
  isShowModal = false;
  currentAudio: MusicAudioViewModel = null;
  categories: CategoryViewModel[] = [];
  coverImageRatio = COVER_IMAGE_RATIO;
  backgroundImageRatio = BACKGROUND_IMAGE_RATIO;
  get title(): string {
    return this.id ? "Редактирование музыки" : "Добавление музыки";
  }
  get id(): number {
    const routeId = this.$route.params.id;
    return routeId ? Number(routeId) : 0;
  }
  vm: CreateMusicViewModel = new CreateMusicViewModel();
  onAnimationChanged(item: AnimationResponse) {
    this.vm.animationUrl = item.Url;
  }
  async created() {
    this.languages = await this.$cacheProvider.getLanguagesAsync();
    this.vm.initLanguages(this.languages);
    const catRes = await this.$api.MusicService.getCategoriesAsync();
    this.categories = (catRes.Items || []).map((x) => new CategoryViewModel(x));
    if (this.$route.params.id) {
      await this.fetchData();
    }
  }
  async fetchData() {
    this.isLoading = true;
    const res = await this.$api.MusicService.getDetailAlbumAsync(this.id);
    this.vm.fromServerModel(res);
    this.isLoading = false;
  }
  async save() {
    const isValid = (this.$refs.validator as any).isValid();
    if (!isValid) return;
    this.isLoading = true;
    const request = this.vm.toServerModel();
    const res = await this.$api.MusicService.updateAlbumAsync(
      request
    );
    if (res) {
      this.$dialog.success("Музыка успешно обновлена");
      this.$router.back();
    }
    this.isLoading = false;
  }
  audioChanged(audio: MusicAudioViewModel) {
    if (audio == null) {
      this.currentAudio = null;
      return;
    }
    if (this.audioAddMode == "edit") {
      Object.assign(this.currentAudio, audio);
    } else if (this.audioAddMode == "add") {
      this.vm.audios.push(audio);
    }
    this.currentAudio == null;
    this.isShowModal = false;
  }
  audioClose() {
    this.isShowModal = false;
  }
  audioAddMode: "edit" | "add" | null = null;
  startAddAudio() {
    const audio = new MusicAudioViewModel();
    audio.initLanguages(this.languages);
    this.currentAudio = audio;
    this.audioAddMode = "add";
    this.isShowModal = true;
  }
  startEditAudio(item: MusicAudioViewModel) { 
    this.currentAudio = item;
    this.audioAddMode = "edit";
    this.isShowModal = true;
  }
  deleteAudio(item: MusicAudioViewModel) {
    this.vm.audios = this.vm.audios.filter((x) => x != item);
  }
}
